import { render, staticRenderFns } from "./CognitiveLevelForm.vue?vue&type=template&id=2f868f08&scoped=true"
import script from "./CognitiveLevelForm.vue?vue&type=script&lang=js"
export * from "./CognitiveLevelForm.vue?vue&type=script&lang=js"
import style0 from "./CognitiveLevelForm.vue?vue&type=style&index=0&id=2f868f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f868f08",
  null
  
)

export default component.exports